import { Grid } from '@mui/material';
import { WsBadge, WsBadgeSize, WsBadgetype } from 'wisestep-base';

export type FiltersTagProp = {
  id: string;
  label: string;
  disableRemove?: boolean;
};

const FiltersTagList = ({
  filterTags,
  onClick,
}: {
  filterTags: FiltersTagProp[];
  onClick: (id: string) => void;
}) => (
  <Grid container spacing={1} width="100%">
    {filterTags.map((tag, index) => (
      <Grid item key={index}>
        <WsBadge
          label={tag.label}
          badgeType={WsBadgetype.INACTIVE}
          badgeSize={WsBadgeSize.LARGE}
          endIcon={!tag?.disableRemove}
          onClick={() => onClick(tag.id)}
        />
      </Grid>
    ))}
  </Grid>
);

export default FiltersTagList;
